@for (m of menuItems; track m) {
  <zwi-tab-button [icon]="m.icon" [label]="m.name" [path]="m.path"></zwi-tab-button>
}

